import { render, staticRenderFns } from "./FormFieldGroupRecView.vue?vue&type=template&id=3b6d4385&scoped=true&"
import script from "./FormFieldGroupRecView.vue?vue&type=script&lang=js&"
export * from "./FormFieldGroupRecView.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldGroupRecView.vue?vue&type=style&index=0&id=3b6d4385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6d4385",
  null
  
)

export default component.exports